<template>
    <div class="header">
        Rock Paper Scissors
    </div>
</template>

<script>
export default {
    name: "HeaderComponent"
}
</script>

<style lang="scss" scoped>
@import "@/assets/global";
.header {
    flex: 0;
    font-size: 3rem;
    padding: 25px;
}
</style>